import { Route, Routes } from "react-router-dom";
import { useSession } from "./auth/client";
import Login from "./routes/Login";
import AppLayout from "./routes/AppLayout";
import Dashboard from "./routes/Dashboard";
import Users from "./routes/Users";
import UserDetail from "./routes/UserDetail";
import Analytics from "./routes/Analytics";

// hq is a self-contained SPA: login lives in-app (no separate auth site, no
// server 302). While the session is loading we render nothing; with no session
// we render <Login/>; otherwise the admin routes. Every /api/* call the routes
// make is independently session-gated server-side.
export default function App() {
  const { data: session, isPending } = useSession();

  if (isPending) return null;
  if (!session) return <Login />;

  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/users" element={<Users />} />
        <Route path="/users/:id" element={<UserDetail />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="*" element={<Dashboard />} />
      </Route>
    </Routes>
  );
}
